var _rect, _rect2, _rect3, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.308,
    y: 1.5,
    width: 21,
    height: 21,
    rx: 6,
    fill: "#1B264F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.308,
    y: 1.5,
    width: 21,
    height: 21,
    rx: 6,
    fill: "#1B264F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.308,
    y: 1.5,
    width: 21,
    height: 21,
    rx: 6,
    fill: "#1B264F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.808 15.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5zm0-1.5a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.308 11.7c0-2.52 0-3.78.49-4.743A4.5 4.5 0 017.766 4.99c.963-.49 2.223-.49 4.743-.49h.6c2.52 0 3.78 0 4.743.49a4.5 4.5 0 011.967 1.967c.49.963.49 2.223.49 4.743v.6c0 2.52 0 3.78-.49 4.743a4.5 4.5 0 01-1.967 1.966c-.962.491-2.223.491-4.743.491h-.6c-2.52 0-3.78 0-4.743-.49A4.5 4.5 0 015.8 17.043c-.49-.963-.49-2.223-.49-4.743v-.6zm7.2-5.7h.6c1.285 0 2.158.001 2.833.056.658.054.995.151 1.23.271a3 3 0 011.31 1.311c.12.235.217.57.27 1.229.056.675.057 1.548.057 2.833v.6c0 1.285-.001 2.158-.056 2.833-.054.658-.151.994-.27 1.229a3 3 0 01-1.312 1.311c-.235.12-.57.217-1.229.27-.675.056-1.548.057-2.833.057h-.6c-1.285 0-2.158-.001-2.833-.056-.658-.054-.994-.151-1.229-.271a3 3 0 01-1.31-1.311c-.12-.235-.218-.57-.272-1.229-.055-.675-.056-1.548-.056-2.833v-.6c0-1.285.001-2.158.056-2.833.054-.658.152-.994.271-1.229a3 3 0 011.311-1.311c.235-.12.571-.217 1.229-.27C10.35 6 11.223 6 12.508 6z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.478 8.067a.819.819 0 11-1.638 0 .819.819 0 011.638 0z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "media/contactForm/instagramIcon-a1a210ae.svg";
export { SvgInstagramIcon as ReactComponent };